import React from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import classNames from 'classnames'

import {load_shops} from '../actions'

const Condition = ({is_active, areaid, categoryid, styleid, children}) => (
  <Link to={{pathname:"/",
     query:{areaid, categoryid, styleid}
    }}
    className={classNames('list-group-item', {'active': is_active})}>

    {children}
  </Link>
)


const mapStateToProps = (state) => {
  return {
    filter:state.filter
  }
}

const mapDispatchToProps = {
  load_shops
}

export default connect(mapStateToProps, mapDispatchToProps)(React.createClass({
  componentWillUpdate: function() {
    this.props.load_shops()
  },

  render: function() {
    const filter = this.props.filter
    return (
      <div>
        <div>
          <div className='list-group shopcond cond-area'>
            <Condition areaid={1} categoryid={filter.categoryid}
              is_active={filter.areaid===1}>
              池袋(北口・西口) </Condition>
            <Condition areaid={2} categoryid={filter.categoryid}
              is_active={filter.areaid===2}>
              池袋(東口) </Condition>
          </div>

          <div className='list-group shopcond cond-category'>
            <Condition areaid={filter.areaid} categoryid={1}
              is_active={filter.categoryid===1}>
              イメクラ </Condition>
            <Condition areaid={filter.areaid} categoryid={2}
              is_active={filter.categoryid===2}>
              ヘルス </Condition>
            <Condition areaid={filter.areaid} categoryid={4}
              is_active={filter.categoryid===4}>
              人妻・熟女 </Condition>
            <Condition areaid={filter.areaid} categoryid={5}
              is_active={filter.categoryid===5}>
              オナクラ </Condition>
            <Condition areaid={filter.areaid} categoryid={6}
              is_active={filter.categoryid===6}>
              ピンサロ </Condition>
          </div>
        </div>
      </div>
    )
  }
}))



// WEBPACK FOOTER //
// ./components/shopmenu.react.js